import styled from "styled-components"

export const StyledTextWidget = styled.div`
    font-size: 22px;

    img {
        border-radius: 4px;
    }
`
